import React, { useEffect, useRef } from 'react';
import {
  View,
  Text,
  StyleSheet,
  ImageBackground,
  Image,
  ActivityIndicator,
  Animated,
  Easing,
} from 'react-native';
import { AppIcons } from '../../assets/images';
import { AppTheme } from '../../utils/theme';

export const AppLoadingFallback: React.FC<{ message?: string }> = ({
  message = 'Loading...',
}) => {
  const pulseAnim = useRef(new Animated.Value(1)).current;
  const glowAnim = useRef(new Animated.Value(0.5)).current;

  useEffect(() => {
    const pulse = Animated.loop(
      Animated.sequence([
        Animated.timing(pulseAnim, {
          toValue: 1.04,
          duration: 900,
          easing: Easing.inOut(Easing.ease),
          useNativeDriver: true,
        }),
        Animated.timing(pulseAnim, {
          toValue: 1,
          duration: 900,
          easing: Easing.inOut(Easing.ease),
          useNativeDriver: true,
        }),
      ])
    );

    const glow = Animated.loop(
      Animated.sequence([
        Animated.timing(glowAnim, {
          toValue: 0.85,
          duration: 1100,
          easing: Easing.inOut(Easing.ease),
          useNativeDriver: true,
        }),
        Animated.timing(glowAnim, {
          toValue: 0.35,
          duration: 1100,
          easing: Easing.inOut(Easing.ease),
          useNativeDriver: true,
        }),
      ])
    );

    pulse.start();
    glow.start();

    return () => {
      pulse.stop();
      glow.stop();
    };
  }, []);

  return (
    <ImageBackground
      source={AppIcons.screenBackground}
      style={styles.container}
      resizeMode="cover"
    >
      {/* Ambient background glow */}
      <Animated.View style={[styles.glowDisc, { opacity: glowAnim }]} />

      <View style={styles.content}>
        <Animated.Image
          source={AppIcons.Logo}
          style={[styles.logo, { transform: [{ scale: pulseAnim }] }]}
          resizeMode="contain"
        />

        <View style={styles.spinnerWrapper}>
          <ActivityIndicator size="large" color="#FCDE26" style={styles.spinner} />
        </View>

        <Text style={styles.loadingText}>{message}</Text>
      </View>
    </ImageBackground>
  );
};

export default AppLoadingFallback;

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFillObject,
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#0b0c1b',
    zIndex: 9999,
  },
  glowDisc: {
    position: 'absolute',
    width: 280,
    height: 280,
    borderRadius: 140,
    backgroundColor: 'rgba(252, 222, 38, 0.12)',
    shadowColor: '#FCDE26',
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.8,
    shadowRadius: 50,
  },
  content: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 20,
  },
  logo: {
    width: 250,
    height: 160,
    marginBottom: 24,
  },
  spinnerWrapper: {
    marginBottom: 16,
  },
  spinner: {
    transform: [{ scale: 1.25 }],
  },
  loadingText: {
    color: AppTheme.colors.white,
    fontSize: 16,
    fontFamily: AppTheme.fonts.ALEXANDRIA_SEMIBOLD,
    textAlign: 'center',
    letterSpacing: 0.8,
    textShadowColor: 'rgba(0, 0, 0, 0.85)',
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 4,
  },
});


